export default function BackgroundBlobs() {
  return (
    <div
      className="pointer-events-none absolute inset-0 -z-0 overflow-hidden"
      data-testid="decorative-background"
      aria-hidden="true"
    >
      <div className="blob blob-1" />
      <div className="blob blob-2" />
      <div className="blob blob-3" />
    </div>
  );
}
